import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first, Subject, takeUntil, withLatestFrom } from 'rxjs';
import { LgvUserService, NotificationService } from '../../core/core.module';
import { EmailCampaignDialogMode } from '../../modules/default/default.enum';

@Component({
    selector: 'lus-email-campain-dialog',
    templateUrl: './email-campain-dialog.component.html',
    styleUrls: ['./email-campain-dialog.component.scss']
})
export class EmailCampainDialogComponent implements OnInit {
    isTermsChecked = false;
    dialogMode = null;
    constructor(public dialogRef: MatDialogRef<EmailCampainDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: LgvUserService,
        private notificationService: NotificationService) { }

    ngOnInit(): void {
        this.dialogMode = this.data.mode;
    }

    onCancel() {
        this.dialogRef.close({
            action: false,
            dialogMode: this.dialogMode
        });
    }

    onContinue() {
        if (this.dialogMode === EmailCampaignDialogMode.Initial) {
            this.sendEmailVerification();
        } else if (this.dialogMode === EmailCampaignDialogMode.Resend) {
            this.resendEmailVerification();
            this.dialogRef.close({
                action: true,
                dialogMode: this.dialogMode === EmailCampaignDialogMode.Resend ? EmailCampaignDialogMode.CheckEmailStatus : this.dialogMode
            });
        }
    }

    onCheckEmailStatus() {
        this.dialogRef.close({
            action: false,
            dialogMode: EmailCampaignDialogMode.CheckEmailStatus
        });
    }

    sendEmailVerification() {
        const requestBody = {
            nickname: this.userService.AgentSS$.value.agentInfo.email,
            from: {
                email: this.userService.AgentSS$.value.agentInfo.email,
                name: this.userService.AgentSS$.value.agentInfo.firstName +
                    this.userService.AgentSS$.value.agentInfo.lastName
            },
            replyTo: {
                email: this.userService.AgentSS$.value.agentInfo.email,
                name: this.userService.AgentSS$.value.agentInfo.firstName +
                    this.userService.AgentSS$.value.agentInfo.lastName
            },
            address: this.userService.AgentSS$.value?.company?.address1,
            city: this.userService.AgentSS$.value?.company?.city,
            state: this.userService.AgentSS$.value?.company?.state,
            zip: this.userService.AgentSS$.value?.company?.zipCode,
            country: 'USA'
        };
        this.userService.sendVerificationEmail(this.userService.AgentID, requestBody).pipe(first()).subscribe(() => {
            this.dialogMode = EmailCampaignDialogMode.Confirmation;
            this.notificationService.success('Email Verification Sent.')
        });
    }

    resendEmailVerification() {
        const requestBody = {
            nickname: this.userService.AgentSS$.value.agentInfo.email,
            from: {
                email: this.userService.AgentSS$.value.agentInfo.email,
                name: this.userService.AgentSS$.value.agentInfo.firstName +
                    this.userService.AgentSS$.value.agentInfo.lastName
            },
            replyTo: {
                email: this.userService.AgentSS$.value.agentInfo.email,
                name: this.userService.AgentSS$.value.agentInfo.firstName +
                    this.userService.AgentSS$.value.agentInfo.lastName
            },
            address: this.userService.AgentSS$.value?.company?.address1,
            city: this.userService.AgentSS$.value?.company?.city,
            state: this.userService.AgentSS$.value?.company?.state,
            zip: this.userService.AgentSS$.value?.company?.zipCode,
            country: 'USA'
        };
        this.userService.resendVerificationEmail(this.userService.AgentID, requestBody).pipe(first()).subscribe(() => {
            this.notificationService.success('Resent Email Verification.')
        });
    }

}
